export default __webpack_public_path__ + "static/media/loading.7c7b1b1f.svg";